
import type { PropType } from 'vue'
import type { EpbTextTag, EpbTextType } from './epb-text.types'

import { computed, defineComponent, ref } from 'vue'
import { ColorEnum } from '../../../enums'

export default defineComponent({
  name: 'EpbText',
  props: {
    tag: {
      type: String as PropType<EpbTextTag>,
      default: 'span',
    },
    type: {
      type: String as PropType<EpbTextType>,
      default: 'default',
    },
    color: {
      type: String,
      default: ColorEnum.NEUTRAL_95,
    },
    showEllipsis: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['click'],
  setup(props, ctx) {
    const baseClass = 'epb-text'
    const textClasses = computed((): string[] => {
      const classes = [baseClass]
      classes.push(`${baseClass}--${props.color}`)
      if (props.type && props.type !== 'default') {
        classes.push(`${baseClass}--${props.type}`)
      }
      if (props.showEllipsis) {
        classes.push(`${baseClass}--ellipsis`)
      }
      return classes
    })

    const textEl = ref(null)

    function focus(): void {
      textEl.value.focus()
    }

    function click(event: MouseEvent): void {
      ctx.emit('click', event)
    }

    return {
      textEl,
      focus,
      textClasses,
      click,
    }
  },
})
